import React from 'react'
import DashboardPage from '../pages/admin_portal/DashboardPage'
import AccountPage from '../pages/admin_portal/AccountPage'
import { Routes, Route, Navigate } from "react-router-dom";
import CompanyPage from '../pages/admin_portal/CompanyPage';
import ProcessPage from '../pages/admin_portal/ProcessPage';
import StagePage from '../pages/admin_portal/StagePage';
// import PricingPage from '../pages/admin_portal/PricingPage';
// import PaymentTermsPage from '../pages/admin_portal/PaymentTermsPage';
import InvoicePage from '../pages/admin_portal/InvoicePage';
import MyProfile from '../pages/admin_portal/MyProfile';
import SmtpConfigPage from '../pages/admin_portal/SmtpConfigPage';
import AssignProcessPage from '../pages/admin_portal/AssignProcessPage';
import EmailNotificationPage from '../pages/admin_portal/EmailNotificationPage';
import CustomerPage from '../pages/admin_portal/CustomerPage';
import { isAuth } from '../helpers/cookies';
import { SUPER_ADMIN } from '../helpers/constants';

const AdminPortalRoutes = () => {
  const isSuperAdmin = Number(isAuth()?.role) === SUPER_ADMIN;
  const superAdminOnly = (element) => (
    isSuperAdmin ? element : <Navigate replace to="/admin/customer/customer" />
  );
  const defaultRoute = isSuperAdmin ? "/admin" : "/admin/customer/customer";

  return (
    <Routes>
      <Route path="/" element={superAdminOnly(<DashboardPage />)} />
      <Route path="/users" element={superAdminOnly(<AccountPage />)} />
      <Route path="/company" element={superAdminOnly(<CompanyPage />)} />
      <Route path="/process" element={superAdminOnly(<ProcessPage />)} />
      <Route path="/customer/customer" element={<CustomerPage />} />
      <Route path="/stage/stage" element={superAdminOnly(<StagePage />)} />
      {/* <Route path="/pricing" element={<PricingPage />} />
      <Route path="/payment-terms" element={<PaymentTermsPage />} /> */}

      <Route path="/invoices" element={superAdminOnly(<InvoicePage />)} />
      <Route path="*" element={<Navigate replace to={defaultRoute} />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="/reports/email_configuration" element={superAdminOnly(<SmtpConfigPage />)} />
      <Route path="/reports/email_notification" element={superAdminOnly(<EmailNotificationPage />)} />
      <Route path="/assign-stage" element={superAdminOnly(<AssignProcessPage />)} />
      <Route path="/stage/assign-stage" element={superAdminOnly(<AssignProcessPage />)} />
    </Routes>
  )
}

export default AdminPortalRoutes;
